import React,{ useEffect, useState, useContext } from "react";
import { NotificationbodyContext } from "./App";
import axios from "axios";
import { token, queryParams, domainurl } from './constants/global';

const HTTPRequest = ({ previousStep,previousValue,triggerNextStep,step,steps,datas}) => {
    console.log("httprequest");
    console.log("steps: ", steps);
    var obj=JSON.parse(datas.Parameters);
    console.log("&&&&&& OBJECT: ", obj)
    
    for (var key in obj) {
        if (obj.hasOwnProperty(key)) {
            var val =obj[key];
            console.log(key);
            var ckey=key.concat("input");
            // console.log("ck:", ckey);
            if(ckey in steps){
              obj[key]=steps[ckey].value;
              console.log(steps[ckey].value);
            }
            else
            {
                if((key in obj) && (!(key in steps)))
                {
                    obj[key]="noinput";
                }
                else
                {
                    obj[key]=steps[key].value;
                    console.log(steps[key].value);
                }    
            }
            
          }
      }

    console.log(JSON.stringify(obj));
    console.log("PREVIOUS STEP MESSAGE", previousStep.message);
    console.log("STEP", step[0]);
    console.log("STEPS", steps);
    console.log({datas});
    console.log("URL", datas.Url);
    console.log("GDJHGDDJHDG",datas.Parameters);
    //console.log("USER",datas.Parameters.usertoken);
    const[msg, setMsg]=useState("Pls wait ....");
    const {notifications, setNotifications} = useContext(NotificationbodyContext);
    console.log(notifications);
    useEffect(()=>{
        if(notifications=='Notopic')
        {
            if(datas.Url!='' || datas.Url!=undefined)
            {
                if(datas.Post==true)
                {
                    var post_data = datas.Parameters.replace("%%",previousStep.message)
                    post_data = datas.Parameters.replace("&&",token)
                    console.log(post_data);
                    axios.post(datas.Url,JSON.stringify(obj))
                    .then(function (response)
                    {
                        console.log(response.data.topic);
                        if(typeof response.data.topic!= "undefined" && response.data.topic!='')
                        {
                            setNotifications(response.data.topic);
                            triggerNextStep({ value: "ss ",trigger:"Liveagent" });
                            //axios.post(domainurl + '/insertchat',{"token":token, "botmsg":event.data, "usermsg": previousStep.message, "client_id": queryParams, "channel":"web"})
                            axios.post(domainurl + '/insertchat',{"token":token, "client_id": "919154313830","channel":"web","usermsg": previousStep.message,"botmsg":event.data})
                        }  
                        else
                        {
                            setMsg(response.data.msg);
                            //axios.post(domainurl + '/insertchat',{"token":token, "botmsg":response.data.msg, "usermsg": previousStep.message, "client_id": queryParams, "channel":"web"})
                            axios.post(domainurl + '/insertchat',{"token":token, "client_id": "919154313830","channel":"web","usermsg": previousStep.message,"botmsg":event.data})
                            
                            if(response.data.trigger!=''||response.data.trigger!=undefined)
                            {
                                triggerNextStep({ value: "ss ",trigger:response.data.trigger });
                            }                            
                        }
                    }) 
                }
                else
                {
                    console.log("IN ELSE CONDITION GET METHOD")
                    
                        axios.get(datas.Url.replace("**",previousStep.message),{})
                        .then(function (response)
                        {
                            console.log("getResp");
                            console.log("*********************************");
                            console.log(response.data.response);
                            console.log("&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&");   
                            setMsg(response.data.response);
                            //axios.post(domainurl + '/insertchat',{"token":token, "botmsg":response.data.msg, "usermsg": previousStep.message, "client_id": queryParams, "channel":"web"})
                            axios.post(domainurl + '/insertchat',{"token":token, "client_id": "919154313830","channel":"web","usermsg": previousStep.message,"botmsg":response.data.response})
                            if(response.data.trigger!=''||response.data.trigger!=undefined)
                            {
                                triggerNextStep({ value: "ss ",trigger:response.data.trigger });
                            }
                        })
                        
                }
                 
            }
        }
    },[]);

    return (
        <div> {msg} </div>
        
    );
   
};
export default HTTPRequest;